import { useState } from "react";
import { Send, CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const ContactForm = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    const name = data.get("name") as string;
    const email = data.get("email") as string;
    const phone = data.get("phone") as string;
    const message = data.get("message") as string;

    const subject = encodeURIComponent(`Demande de devis - ${name}`);
    const body = encodeURIComponent(
      `Nom : ${name}\nEmail : ${email}\nTéléphone : ${phone}\n\nMessage :\n${message}`
    );
    window.location.href = `mailto:contact@proimpact.ch?subject=${subject}&body=${body}`;
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="glass-card rounded-lg p-8 text-center max-w-lg mx-auto">
        <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-4" />
        <h3 className="text-xl font-bold mb-2">Message préparé !</h3>
        <p className="text-sm text-muted-foreground">
          Votre client email s'est ouvert avec le message pré-rempli.
          Vous pouvez aussi nous appeler au{" "}
          <a href="tel:+41766388655" className="text-primary font-semibold">
            +41 76 638 86 55
          </a>.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="glass-card rounded-lg p-6 sm:p-8 max-w-lg mx-auto">
      <h3 className="text-xl font-bold tracking-tight mb-1">Demander un devis gratuit</h3>
      <p className="text-sm text-muted-foreground mb-6">
        Décrivez votre besoin, nous vous répondons sous 24h.
      </p>

      <div className="space-y-4">
        <div>
          <label htmlFor="contact-name" className="block text-sm font-medium mb-1.5">
            Nom complet <span className="text-destructive">*</span>
          </label>
          <input
            id="contact-name"
            name="name"
            type="text"
            required
            autoComplete="name"
            className="w-full rounded-lg border border-input bg-background px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-ring transition-shadow"
            placeholder="Votre nom"
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label htmlFor="contact-email" className="block text-sm font-medium mb-1.5">
              Email <span className="text-destructive">*</span>
            </label>
            <input
              id="contact-email"
              name="email"
              type="email"
              required
              autoComplete="email"
              className="w-full rounded-lg border border-input bg-background px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-ring transition-shadow"
              placeholder="votre@email.ch"
            />
          </div>
          <div>
            <label htmlFor="contact-phone" className="block text-sm font-medium mb-1.5">
              Téléphone
            </label>
            <input
              id="contact-phone"
              name="phone"
              type="tel"
              autoComplete="tel"
              className="w-full rounded-lg border border-input bg-background px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-ring transition-shadow"
              placeholder="+41 7X XXX XX XX"
            />
          </div>
        </div>

        <div>
          <label htmlFor="contact-message" className="block text-sm font-medium mb-1.5">
            Décrivez les dégâts <span className="text-destructive">*</span>
          </label>
          <textarea
            id="contact-message"
            name="message"
            required
            rows={4}
            className="w-full rounded-lg border border-input bg-background px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-ring transition-shadow resize-none"
            placeholder="Type de véhicule, nature des dégâts, numéro d'assurance si applicable..."
          />
        </div>

        <Button type="submit" className="w-full gap-2 h-12 text-base">
          <Send className="w-4 h-4" /> Envoyer la demande
        </Button>

        <p className="text-xs text-muted-foreground text-center">
          En soumettant ce formulaire, vous acceptez notre{" "}
          <a href="/politique-confidentialite" className="underline hover:text-primary">
            politique de confidentialité
          </a>.
        </p>
      </div>
    </form>
  );
};

export default ContactForm;
